import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import classNames from 'classnames';
import { StarRatingButton } from '@fff-web/fff-ratings-and-reviews';

import styles from './styles.module.scss';

const ProductItem = ({
  productId,
  imageUrl,
  productBrand,
  productName,
  rating,
  onClick,
}) => {
  const handleOnClick = (value) => onClick(productId, value);

  return (
    <LazyLoad className={classNames(styles.container, {[styles.disabled]: rating > 0})} once>
      <button type="button" onClick={() => handleOnClick(0)}>
        <img src={imageUrl} alt={productName} />
      </button>
      <div className={styles.details}>
        <p className={styles.brand}>{productBrand}</p>
        <p className={styles.name}>{productName}</p>
        <div className={styles.ratingContainer}>
          <StarRatingButton
            name={productId}
            size={24}
            containerWidth={184}
            defaultValue={rating}
            onClick={handleOnClick}
          />
        </div>
      </div>
    </LazyLoad>
  );
};

ProductItem.propTypes = {
  productId: PropTypes.number.isRequired,
  imageUrl: PropTypes.string.isRequired,
  productBrand: PropTypes.string,
  productName: PropTypes.string.isRequired,
  rating: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
};

ProductItem.defaultProps = {
  productBrand: null,
};

export default ProductItem;
